module.exports = __webpack_public_path__ + "media/images/suppliers/omics-4803b4ac3ced119002702d863676d64c.png";